import script from "./icon-arrow-left.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-arrow-left.vue?vue&type=script&lang=ts&setup=true"

import "./icon-arrow-left.vue?vue&type=style&index=0&id=2a188a8a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a188a8a"]])

export default __exports__